export default __webpack_public_path__ + "static/media/logo-leclerc-mobile.9c8d373b.svg";